export default __webpack_public_path__ + "static/media/chevronLeft.f133dde1.svg";